import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  communicationPreferences: {
    id: 'accountSettings.communicationPreferences',
    defaultMessage: 'Communication preferences',
  },
  editEmail: {
    id: 'accountSettings.editEmail',
    defaultMessage: 'New email login',
  },
  mfa: {
    id: 'accountSettings.mfa',
    defaultMessage: '2-Factor authentication',
  },
  newPassword: {
    id: 'accountSettings.newPassword',
    defaultMessage: 'New password',
  },
  settings: {
    id: 'accountSettings.settings',
    defaultMessage: 'Settings',
  },
})
